import { render, staticRenderFns } from "./SmsSubscribe.vue?vue&type=template&id=1889d844&lang=pug"
import script from "./SmsSubscribe.vue?vue&type=script&lang=js"
export * from "./SmsSubscribe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports